<app-chart-image *ngIf="chart" [chart]="chart" (chartDataUpdate)="onChartDataUdate($event)"></app-chart-image>